import { keyBy } from 'lodash';

export const getActionAuthorization = (actions, resource) => {
  const actionsByResource = keyBy(actions, 'resource');

  return !!actionsByResource[resource];
};
